import store from "store";
import UserPersistence from "./UserPersistence";

const KEY_PAGE_OPENED_LIST = "pageOpenedList";
const KEY_PAGE_CACHED_LIST = "pageCachedList";
const KEY_USER_INFO = "userInfo";

export default {

  saveOpenedPageList(pageList) {
    let user = UserPersistence.getBaseInfo().user;
    let ID = user? user.id : '';
    let TYPE = UserPersistence.getServiceType() || '';
    store.set(KEY_PAGE_OPENED_LIST, pageList);
  },

  getOpenedPageList() {
    let user = UserPersistence.getBaseInfo().user;
    let ID = user? user.id : '';
    let TYPE = UserPersistence.getServiceType() || '';
    return store.get(KEY_PAGE_OPENED_LIST);
  },

  saveCachePageList(cachePageList) {
    let user = UserPersistence.getBaseInfo().user;
    let ID = user? user.id : '';
    let TYPE = UserPersistence.getServiceType() || '';
    store.set(KEY_PAGE_CACHED_LIST + ID + TYPE, cachePageList);
  },
  getCachePageList() {
    let user = UserPersistence.getBaseInfo().user;
    let ID = user? user.id : '';
    let TYPE = UserPersistence.getServiceType() || '';
    return store.get(KEY_PAGE_CACHED_LIST + ID + TYPE);
  },

  saveUserInfo(Info) {
    let name = Info.name;
    let pwd = Info.pwd;
    let info = store.get(KEY_USER_INFO);
    if (info === undefined) {
      info = {};
    }
    if (pwd){
      info[name] = pwd;
    }else{
      delete info[name]
    }
    store.set(KEY_USER_INFO,info);
  },
  getUserInfo() {
    return store.get(KEY_USER_INFO);
  },

  clear() {
    let baseInfo = UserPersistence.getBaseInfo();
    if(JSON.stringify(baseInfo) === '{}'){
      return
    }
    let ID = baseInfo ? baseInfo.user.id : '';
    let TYPE = UserPersistence.getServiceType() || '';
    store.remove(KEY_PAGE_OPENED_LIST + ID + TYPE, null);
  },

  removeAll() {//移除所有local storage
    for(let key in window.localStorage){
      if(key !== 'frontendVersion') {
        store.remove(key);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/persistence/AppPersistence.js